import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import { push } from "react-router-redux";
import Helper from "../../helpers/helpers";

export function* loadGraderList() {
  
  yield takeEvery(actionTypes.LOAD_GRADER_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let status = (action.data.verifyStatus) ? action.data.verifyStatus : ""
    let service_type = (action.data.service_type) ? action.data.service_type : ""
    let search = (action.data.search) ? action.data.search : ""
    
    let track_no = Helper.generateTrackNo(`GRADERLIST${status}${service_type}${search}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderListFail());
    }
  });
}
  


export function* graderCount() {
  
  yield takeEvery(actionTypes.GRADER_COUNT, function*(action) {

    let track_no = Helper.generateTrackNo("GRADERCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderCountFail());
    }
  });
}

export function* editGraderDetail() {
  yield takeEvery(actionTypes.EDIT_GRADER_DETAIL, function*(action) {

    let track_no = Helper.generateTrackNo("EDITGRADERDETAIL");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editGraderDetail(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editGraderDetailSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editGraderDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editGraderDetailFail());
    }
  });
}

export function* setGraderQRCode() {
  yield takeEvery(actionTypes.EDIT_GRADER_QRCODE, function*(action) {

    let track_no = Helper.generateTrackNo("EDITGRADERQRCODE");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setGraderQRCode(action.id, action.data);
      if (response.data.success) {
        yield put(actions.setGraderQRCodeSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setGraderQRCodeFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setGraderQRCodeFail());
    }
  });
}

export function* removeGrader() {
  yield takeEvery(actionTypes.REMOVE_GRADER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEGRADER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeGrader(action.id, action.data);
      if (response.data.success) {
        if(response.data.data)
        {
          yield put(actions.removeGraderSuccess(response.data.data));

        }else{
          yield put(actions.removeGraderSuccess());
          yield put(actions.toastSuccess(response.data.message));
          yield put(push("/grader"));

        }
      } else {
        alert(response.data.message);
        yield put(actions.removeGraderFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeGraderFail());
    }
  });
}

export function* recoveryGrader() {
  yield takeEvery(actionTypes.RECOVERY_GRADER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECOVERYGRADER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.recoveryGrader(action.id, action.data);
      if (response.data.success) {
        
        yield put(actions.recoveryGraderSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.recoveryGraderFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.recoveryGraderFail());
    }
  });
}

export function* editGraderStatus() {
  yield takeEvery(actionTypes.EDIT_GRADER_STATUS, function*(action) {

    let track_no = Helper.generateTrackNo("EDITGRADERSTATUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editGraderStatus(action.id, action.data);
      if (response.data.success) {

        if(response.data.data && response.data.data.updateOrder)
        {
          yield put(actions.proceedUpdateOrderLandfill(response.data.data));

        }else if(response.data.data && response.data.data.confirmDeactivate)
        {
          yield put(actions.proceedDeactivateConfirm(response.data.data));

        }else{
          yield put(actions.editGraderStatusSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }
        // if(action.listParams)
        //   yield put(actions.loadGraderList(action.listParams));
        // else
        //   yield put(actions.loadGraderDetail(action.id));
      } else {
        alert(response.data.message);
        yield put(actions.editGraderStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editGraderStatusFail());
    }
  });
}

export function* editGraderVerifyStatus() {
  yield takeEvery(actionTypes.EDIT_GRADER_VERIFY_STATUS, function*(action) {

    let track_no = Helper.generateTrackNo("EDITGRADERVERIFYSTATUS");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editGraderVerifyStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editGraderVerifyStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.editGraderVerifyStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editGraderVerifyStatusFail());
    }
  });
}


export function* rejectGraderVerifyStatus() {
  yield takeEvery(actionTypes.REJECT_GRADER_VERIFY_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REJECTGRADERVERIFYSTATUS");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.rejectGraderVerifyStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.rejectGraderVerifyStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.rejectGraderVerifyStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.rejectGraderVerifyStatusFail());
    }
  });
}

export function* updatePrinterBinding() {
  yield takeEvery(actionTypes.UPDATE_PRINTER_BINDING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDATEPRINTERBINDING");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updatePrinterBinding(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updatePrinterBindingSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.updatePrinterBindingFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updatePrinterBindingFail());
    }
  });
}

export function* editGraderPublishStatus() {
  yield takeEvery(actionTypes.EDIT_GRADER_PUBLISH_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITGRADERPUBLISHSTATUS");

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editGraderPublishStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editGraderPublishStatusSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.editGraderPublishStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editGraderPublishStatusFail());
    }
  });
}

export function* loadGraderDetail() {
  
  yield takeEvery(actionTypes.LOAD_GRADER_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERDETAIL");
    action.data.track_no = track_no


    yield put(actions.enableLoading());
    try {
      const response = yield API.loadGraderDetail(action.id, action.data);
      
      if (response.data.success && response.data.data) {
        
        yield put(actions.loadGraderDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderDetailFail());
    }
  });
}



export function* uploadGraderDoc() {
  yield takeEvery(actionTypes.UPLOAD_GRADER_DOC, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPLOADGRADERDOC");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.uploadGraderDoc(action.id, action.data);
      if (response.data.success) {
        
        yield put(actions.uploadGraderDocSuccess());
        
      } else {
        alert(response.data.message);
        yield put(actions.uploadGraderDocFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.uploadGraderDocFail());
    }
  });
}
  


export function* uploadGraderBizImage() {
  yield takeEvery(actionTypes.UPLOAD_GRADER_BIZ_IMAGE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPLOADGRADERBIZIMAGE");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);

    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.uploadGraderBizImage(action.id, action.data);
      if (response.data.success) {

        yield put(actions.uploadGraderBizImageSuccess());

      } else {
        alert(response.data.message);
        yield put(actions.uploadGraderBizImageFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.uploadGraderBizImageFail());
    }
  });
}


export function* removeGraderBizImage() {
  yield takeEvery(actionTypes.REMOVE_GRADER_BIZ_IMAGE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEGRADERBIZIMAGE");

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeGraderBizImage(action.id, action.data);
      if (response.data.success) {

        yield put(actions.removeGraderBizImageSuccess());

      } else {
        alert(response.data.message);
        yield put(actions.removeGraderBizImageFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeGraderBizImageFail());
    }
  });
}


export function* loadGraderDocumentationCount() {
  
  yield takeEvery(actionTypes.GRADER_DOCUMENTATION_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERDOCUMENTATIONCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderDocumentationCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderDocumentationCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderDocumentationCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderDocumentationCountFail());
    }
  });
}


export function* loadGraderDocumentationList() {
  
  yield takeEvery(actionTypes.GRADER_DOCUMENTATION_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let graderID = (action.data.grader_id) ? action.data.grader_id : ""
    let search = (action.data.search) ? action.data.search : ""
    let acc_verified = (action.data.acc_verified) ? "acc_verified" : ""
    let pending_verified = (action.data.pending_verified) ? "pending_verified" : ""
    
    let track_no = Helper.generateTrackNo(`GRADERDOCLIST${graderID}${search}${acc_verified}${pending_verified}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderDocumentationList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderDocumentationListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderDocumentationListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderDocumentationListFail());
    }
  });
}


export function* resetGraderDocumentationList() {
  
  yield takeEvery(actionTypes.RESET_GRADER_DOCUMENTATION_LIST, function*(action) {
    
    yield put(actions.loadGraderDocumentationListSuccess([]));
  });
}


export function* approveGraderDocumentation() {
  
  yield takeEvery(actionTypes.APPROVE_GRADER_DOCUMENTATION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("APPROVEGRADERDOCUMENTATION");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.approveGraderDocumentation(action.data);
      if (response.data.success) {
        yield put(actions.approveGraderDocumentationSuccess());
      } else {
        alert(response.data.message);
        yield put(actions.approveGraderDocumentationFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.approveGraderDocumentationFail());
    }
  });
}



export function* rejectGraderDocumentation() {
  
  yield takeEvery(actionTypes.REJECT_GRADER_DOCUMENTATION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REJECTGRADERDOCUMENTATION");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.rejectGraderDocumentation(action.data);
      if (response.data.success) {
        yield put(actions.rejectGraderDocumentationSuccess());
      } else {
        alert(response.data.message);
        yield put(actions.rejectGraderDocumentationFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.rejectGraderDocumentationFail());
    }
  });
}

export function* loadGraderDeviceList() {
  
  yield takeEvery(actionTypes.LOAD_GRADER_DEVICE_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let search = (action.data.search) ? action.data.search : ""
    let dev_mode = (action.data.dev_mode) ? action.data.dev_mode : ""
    let grader_id = (action.data.grader_id) ? action.data.grader_id : ""
    
    let track_no = Helper.generateTrackNo(`GRADERDEVICELIST${search}${dev_mode}${grader_id}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderDeviceList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderDeviceListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderDeviceListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderDeviceListFail());
    }
  });
}
export function* logoutGraderDevice() {
  yield takeEvery(actionTypes.LOGOUT_GRADER_DEVICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LOGOUTGRADERDEVICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.logoutGraderDevice(action.id, action.data);
      if (response.data.success) {
        
        yield put(actions.logoutGraderDeviceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.logoutGraderDeviceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.logoutGraderDeviceFail());
    }
  });
}

export function* removeGraderDevice() {
  yield takeEvery(actionTypes.REMOVE_GRADER_DEVICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEGRADERDEVICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeGraderDevice(action.id, action.data);
      if (response.data.success) {
        
        yield put(actions.removeGraderDeviceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.removeGraderDeviceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeGraderDeviceFail());
    }
  });
}

export function* devModeGraderDevice() {
  yield takeEvery(actionTypes.SET_GRADER_DEVICE_DEV_MODE, function*(action) {

    let track_no = Helper.generateTrackNo("GRADERDEVICEDEV");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.devModeGraderDevice(action.id, action.data);
      if (response.data.success) {

        yield put(actions.devModeGraderDeviceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.devModeGraderDeviceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.devModeGraderDeviceFail());
    }
  });
}


/* ===== GRADER ZONE ===== */
export function* loadGraderZoneList() {
  
  yield takeEvery(actionTypes.LOAD_GRADER_ZONE_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let status = (action.data.verifyStatus) ? action.data.verifyStatus : ""
    let search = (action.data.search) ? action.data.search : ""
    
    let track_no = Helper.generateTrackNo(`GRADERZONELIST${status}${search}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderZoneList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderZoneListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderZoneListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderZoneListFail());
    }
  });
}

export function* graderZoneCount() {
  
  yield takeEvery(actionTypes.GRADER_ZONE_COUNT, function*(action) {

    let track_no = Helper.generateTrackNo("GRADERZONECOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderZoneCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderZoneCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderZoneCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderZoneCountFail());
    }
  });
}


export function* expressPackingHistoryList() {
  
  yield takeEvery(actionTypes.LOAD_EXPRESS_PACKING_HISTORY_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let grader_id = (action.data.grader_id) ? action.data.grader_id : ""
    let search = (action.data.search) ? action.data.search : ""
    let dateFrom = (action.data.dateFrom) ? action.data.dateFrom : ""
    let dateTo = (action.data.dateTo) ? action.data.dateTo : ""
    
    let track_no = Helper.generateTrackNo(`EXPRESSPACKINGHISTORYLIST${grader_id}${search}${dateFrom}${dateTo}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.expressPackingHistoryList(action.data);
      if (response.data.success && response.data.data) {
        if(response.data.data.export)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }
        
        yield put(actions.expressPackingHistoryListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.expressPackingHistoryListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.expressPackingHistoryListFail());
    }
  });
} 

export function* expressPackingListDetail() {
  
  yield takeEvery(actionTypes.LOAD_EXPRESS_PACKING_LIST_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EXPRESSPACKINGDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.expressPackingListDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.expressPackingListDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.expressPackingListDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.expressPackingListDetailFail());
    }
  });
}
  
export function* getExpressPackingListPDF() {
  
  yield takeEvery(actionTypes.GET_EXPRESS_PACKING_LIST_PDF, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETEXPRESSPACKINGLISTPDF");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getExpressPackingListPDF(action.id, action.data);
      if (response.data.success && response.data.data) {
        
        
        yield put(actions.getExpressPackingListPDFSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getExpressPackingListPDFFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getExpressPackingListPDFFail());
    }
  });
}
  
export function* getExpressPackingListStack() {
  
  yield takeEvery(actionTypes.GET_EXPRESS_PACKING_LIST_STACK, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETEXPRESSPACKINGLISTSTACK");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getExpressPackingListStack(action.data);
      if (response.data.success && response.data.data) {
        
        yield put(actions.getExpressPackingListStackSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getExpressPackingListStackFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getExpressPackingListStackFail());
    }
  });
}


export function* recyclingPackingHistoryList() {
  
  yield takeEvery(actionTypes.LOAD_RECYCLING_PACKING_HISTORY_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let grader_id = (action.data.grader_id) ? action.data.grader_id : ""
    let search = (action.data.search) ? action.data.search : ""
    let dateFrom = (action.data.dateFrom) ? action.data.dateFrom : ""
    let dateTo = (action.data.dateTo) ? action.data.dateTo : ""
    
    let track_no = Helper.generateTrackNo(`RECYCLINGPACKINGHISTORYLIST${grader_id}${search}${dateFrom}${dateTo}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.recyclingPackingHistoryList(action.data);
      if (response.data.success && response.data.data) {
        if(response.data.data.export)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }
        yield put(actions.recyclingPackingHistoryListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.recyclingPackingHistoryListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.recyclingPackingHistoryListFail());
    }
  });
}
  
export function* recyclingPackingListDetail() {
  
  yield takeEvery(actionTypes.LOAD_RECYCLING_PACKING_LIST_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECYCLINGPACKINGDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.recyclingPackingListDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        
        yield put(actions.recyclingPackingListDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.recyclingPackingListDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.recyclingPackingListDetailFail());
    }
  });
}
  
export function* getRecyclingPackingListPDF() {
  
  yield takeEvery(actionTypes.GET_RECYCLING_PACKING_LIST_PDF, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETRECYCLINGPACKINGLISTPDF");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getRecyclingPackingListPDF(action.id, action.data);
      if (response.data.success && response.data.data) {
        
        yield put(actions.getRecyclingPackingListPDFSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getRecyclingPackingListPDFFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getRecyclingPackingListPDFFail());
    }
  });
}
  
export function* getRecyclingPackingListStack() {
  
  yield takeEvery(actionTypes.GET_RECYCLING_PACKING_LIST_STACK, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETRECYCLINGPACKINGLISTSTACK");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getRecyclingPackingListStack(action.data);
      if (response.data.success && response.data.data) {
        
        yield put(actions.getRecyclingPackingListStackSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getRecyclingPackingListStackFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getRecyclingPackingListStackFail());
    }
  });
}

/* ===== GRADER ZONE ===== */

export function* graderCarbonStockList() {
  
  yield takeEvery(actionTypes.LOAD_GRADER_CARBON_STOCK_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERCARBONSTOCKLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.graderCarbonStockList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderCarbonStockListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderCarbonStockListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderCarbonStockListFail());
    }
  });
}


export function* graderCarbonStockSet() {
  yield takeEvery(actionTypes.SET_GRADER_CARBON_STOCK, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETGRADERCARBONSTOCK");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderCarbonStockSet(action.id, action.data);
      if (response.data.success) {

        yield put(actions.graderCarbonStockSetSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.graderCarbonStockSetFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderCarbonStockSetFail());
    }
  });
}

export function* graderCarbonStockRemove() {
  yield takeEvery(actionTypes.REMOVE_GRADER_CARBON_STOCK, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEGRADERCARBONSTOCK");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderCarbonStockRemove(action.id, action.data);
      if (response.data.success) {

        yield put(actions.graderCarbonStockRemoveSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.graderCarbonStockRemoveFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderCarbonStockRemoveFail());
    }
  });
}


/* ===== GRADER PRINTER ===== */

export function* createGraderPrinter() {
  yield takeEvery(actionTypes.CREATE_GRADER_PRINTER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CREATEGRADERPRINTER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.createGraderPrinter(action.data);
      if (response.data.success) {
        yield put(actions.createGraderPrinterSuccess(response.data.data));
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.createGraderPrinterFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.createGraderPrinterFail());
    }
  });
}

export function* editGraderPrinter() {
  yield takeEvery(actionTypes.EDIT_GRADER_PRINTER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITGRADERPRINTER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editGraderPrinter(action.id, action.data);
      if (response.data.data && response.data.data.status === false && response.data.data.reassign_confirmed) {
        yield put(actions.editGraderPrinterConfirm(response.data.data));

      } else if (response.data.success) {
        yield put(actions.editGraderPrinterSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editGraderPrinterFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editGraderPrinterFail());
    }
  });
}

export function* graderPrinterCount() {
  yield takeEvery(actionTypes.GRADER_PRINTER_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERPRINTERCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderPrinterCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderPrinterCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderPrinterCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderPrinterCountFail());
    }
  });
}

export function* loadGraderPrinterList() {
  yield takeEvery(actionTypes.LOAD_GRADER_PRINTER_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERPRINTERLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderPrinterList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderPrinterListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderPrinterListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderPrinterListFail());
    }
  });
}

export function* loadGraderPrinterDetail() {
  yield takeEvery(actionTypes.LOAD_GRADER_PRINTER_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERPRINTERDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderPrinterDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderPrinterDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderPrinterDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderPrinterDetailFail());
    }
  });
}

export function* removeGraderPrinter() {
  yield takeEvery(actionTypes.REMOVE_GRADER_PRINTER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEGRADERPRINTER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeGraderPrinter(action.id, action.data);
      if (response.data.data && response.data.data.status === false && response.data.data.cancel_confirmed) {
        yield put(actions.removeGraderPrinterConfirm(response.data.data));

      } else if (response.data.success) {
        yield put(actions.removeGraderPrinterSuccess(response.data.data));
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeGraderPrinterFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeGraderPrinterFail());
    }
  });
}

export function* loadGraderPrinterTaskDistance() {
  yield takeEvery(actionTypes.LOAD_GRADER_PRINTER_TASK_DISTANCE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERPRINTERTASKDISTANCE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderPrinterTaskDistance(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderPrinterTaskDistanceSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderPrinterTaskDistanceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderPrinterTaskDistanceFail());
    }
  });
}

export function* loadGraderPrinterStatusLog() {
  yield takeEvery(actionTypes.LOAD_GRADER_PRINTER_STATUS_LOG, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERPRINTERSTATUSLOG");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderPrinterStatusLog(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderPrinterStatusLogSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderPrinterStatusLogFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderPrinterStatusLogFail());
    }
  });
}

export function* loadGraderPrinterErrorLog() {
  yield takeEvery(actionTypes.LOAD_GRADER_PRINTER_ERROR_LOG, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERPRINTERERRORLOG");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderPrinterErrorLog(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderPrinterErrorLogSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderPrinterErrorLogFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderPrinterErrorLogFail());
    }
  });
}
/* ===== END GRADER PRINTER ===== */



export default function* graderSaga() {
  yield all([fork(loadGraderList)]);
  yield all([fork(graderCount)]);
  yield all([fork(editGraderDetail)]);
  yield all([fork(setGraderQRCode)]);
  yield all([fork(removeGrader)]); 
  yield all([fork(recoveryGrader)]);
  yield all([fork(editGraderStatus)]);
  yield all([fork(editGraderVerifyStatus)]);
  yield all([fork(rejectGraderVerifyStatus)]);
  yield all([fork(updatePrinterBinding)]);
  yield all([fork(editGraderPublishStatus)]);
  yield all([fork(loadGraderDetail)]);
  yield all([fork(uploadGraderDoc)]);
  yield all([fork(uploadGraderBizImage)]);
  yield all([fork(removeGraderBizImage)]);
  yield all([fork(loadGraderDocumentationCount)]);
  yield all([fork(loadGraderDocumentationList)]);
  yield all([fork(resetGraderDocumentationList)]);
  yield all([fork(approveGraderDocumentation)]);
  yield all([fork(rejectGraderDocumentation)]);
  
  yield all([fork(loadGraderDeviceList)]);
  yield all([fork(logoutGraderDevice)]);
  yield all([fork(removeGraderDevice)]);
  yield all([fork(devModeGraderDevice)]);

  yield all([fork(loadGraderZoneList)]);
  yield all([fork(graderZoneCount)]);
  yield all([fork(expressPackingHistoryList)]);
  yield all([fork(expressPackingListDetail)]);
  yield all([fork(getExpressPackingListPDF)]);
  yield all([fork(getExpressPackingListStack)]);
  yield all([fork(recyclingPackingHistoryList)]);
  yield all([fork(recyclingPackingListDetail)]);
  yield all([fork(getRecyclingPackingListPDF)]);
  yield all([fork(getRecyclingPackingListStack)]);
  
  yield all([fork(graderCarbonStockList)]);
  yield all([fork(graderCarbonStockSet)]);
  yield all([fork(graderCarbonStockRemove)]);

  yield all([fork(createGraderPrinter)]);
  yield all([fork(editGraderPrinter)]);
  yield all([fork(graderPrinterCount)]);
  yield all([fork(loadGraderPrinterList)]);
  yield all([fork(loadGraderPrinterDetail)]);
  yield all([fork(removeGraderPrinter)]);
  yield all([fork(loadGraderPrinterTaskDistance)]);
  yield all([fork(loadGraderPrinterStatusLog)]);
  yield all([fork(loadGraderPrinterErrorLog)]);
}
